export default function AgendaItemDocumentDirective() {
  return {
    template: require('./agendaItem-document.html'),
    scope: {
      agendaItemId: '=',
      canDelete: '=',
      agendaItemDocumentDetail: '=',
      isInDialog: '='
    },
    controller: 'AgendaItemDocumentController',
    controllerAs: 'agendaItemDocumentVM',
    bindToController: true,
    replace: true
  };
}
